/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
// <!-- Люкс -->
// <a href="#" data-tl-booking-open="true" data-tl-room="46394" >Забронировать</a>
// <!-- Стандарт с дополнительным местом -->
// <a href="#" data-tl-booking-open="true" data-tl-room="46396" >Забронировать</a>
// <!-- JUNIOR SUITE -->
// <a href="#" data-tl-booking-open="true" data-tl-room="46419" >Забронировать</a>
// <!-- Стандарт 2-х местный -->
// <a href="#" data-tl-booking-open="true" data-tl-room="50934" >Забронировать</a>
// <!-- Стандарт мансарда с дополнительным местом -->
// <a href="#" data-tl-booking-open="true" data-tl-room="74596" >Забронировать</a>
// <!-- Стандарт мансарда 2-х местный -->
// <a href="#" data-tl-booking-open="true" data-tl-room="116078" >Забронировать</a>
// <!-- Стандарт TWIN -->
// <a href="#" data-tl-booking-open="true" data-tl-room="116079" >Забронировать</a>
// <!-- Стандарт мансарда -->
// <a href="#" data-tl-booking-open="true" data-tl-room="141543" >Забронировать</a>
// <!-- Стандарт DUPLEX -->
// <a href="#" data-tl-booking-open="true" data-tl-room="141579" >Забронировать</a>
// <!-- JUNIOR SUITE  (полулюкс двухуровневый) -->
// <a href="#" data-tl-booking-open="true" data-tl-room="144945" >Забронировать</a>
// <!-- Двухуровневый мансардный Люкс -->
// <a href="#" data-tl-booking-open="true" data-tl-room="147754" >Забронировать</a>
// <!-- ШАЛЕ- КОТТЕДЖ  ПОВЫШЕННОЙ КОМФОРТНОСТИ -->
// <a href="#" data-tl-booking-open="true" data-tl-room="180134" >Забронировать</a>
// <!-- ШАЛЕ- КОТТЕДЖ  ПОВЫШЕННОЙ КОМФОРТНОСТИ -->
// <a href="#" data-tl-booking-open="true" data-tl-room="180136" >Забронировать</a>
// <!-- JUNIOR SUITE  STUDIO -->
// <a href="#" data-tl-booking-open="true" data-tl-room="223181" >Забронировать</a>
// <!-- Стандарт DUPLEX с дополнительным местом -->
// <a href="#" data-tl-booking-open="true" data-tl-room="225020" >Забронировать</a>
// <!-- Cinema Capsula -->
// <a href="#" data-tl-booking-open="true" data-tl-room="228051" >Забронировать</a>
export const store = new Vuex.Store({
	state: {
		screenScrolled: 0,
		screenWidth: 0,
		screenHeight: 0,
		isModalShow: false,
		housing_items: [
			{
				id:  1,
				data_tl_room: '180134,180136',
				type: {
					id: 2,
					name: 'chalet',
					img: require('../assets/img/housing_options/chalet_item_img.jpg'),
					video: '',
				},
				active: false,
				title: 'ШАЛЕ',
				subtitle: '',
				imgs: [

					{id: 3, src: require('../../src/assets/img/aparts/shale-kottedzh/hr-43-iz-166.jpg'), active: false},
					{id: 4, src: require('../../src/assets/img/aparts/shale-kottedzh/hr-44-iz-166.jpg'), active: false},
					{id: 5, src: require('../../src/assets/img/aparts/shale-kottedzh/hr-45-iz-166.jpg'), active: false},
					{id: 6, src: require('../../src/assets/img/aparts/shale-kottedzh/hr-46-iz-166.jpg'), active: false},
					{id: 7, src: require('../../src/assets/img/aparts/shale-kottedzh/hr-47-iz-166.jpg'), active: false},
					{id: 8, src: require('../../src/assets/img/aparts/shale-kottedzh/hr-48-iz-166.jpg'), active: false},
					{id: 9, src: require('../../src/assets/img/aparts/shale-kottedzh/hr-49-iz-166.jpg'), active: false},
					{id: 10, src: require('../../src/assets/img/aparts/shale-kottedzh/hr-50-iz-166.jpg'), active: false},
					{id: 11, src: require('../../src/assets/img/aparts/shale-kottedzh/hr-51-iz-166.jpg'), active: false},
					{id: 12, src: require('../../src/assets/img/aparts/shale-kottedzh/hr-52-iz-166.jpg'), active: false},
					{id: 13, src: require('../../src/assets/img/aparts/shale-kottedzh/hr-53-iz-166.jpg'), active: false},
					{id: 14, src: require('../../src/assets/img/aparts/shale-kottedzh/hr-54-iz-166.jpg'), active: false},
					{id: 15, src: require('../../src/assets/img/aparts/shale-kottedzh/hr-55-iz-166.jpg'), active: false},
					{id: 16, src: require('../../src/assets/img/aparts/shale-kottedzh/hr-56-iz-166.jpg'), active: false},
					{id: 1, src: require('../../src/assets/img/aparts/shale-kottedzh/hr-7-iz-166.jpg'), active: false},
					{id: 2, src: require('../../src/assets/img/aparts/shale-kottedzh/hr-42-iz-166.jpg'), active: false},
					{id: 17, src: require('../../src/assets/img/aparts/shale-kottedzh/hr-57-iz-166.jpg'), active: false},
					{id: 18, src: require('../../src/assets/img/aparts/shale-kottedzh/hr-58-iz-166.jpg'), active: false},
					{id: 20, src: require('../../src/assets/img/aparts/shale-kottedzh/hr-60-iz-166.jpg'), active: false},
					{id: 21, src: require('../../src/assets/img/aparts/shale-kottedzh/hr-61-iz-166.jpg'), active: false},
					{id: 22, src: require('../../src/assets/img/aparts/shale-kottedzh/hr-62-iz-166.jpg'), active: false},
					{id: 24, src: require('../../src/assets/img/aparts/shale-kottedzh/hr-64-iz-166.jpg'), active: false},
					{id: 25, src: require('../../src/assets/img/aparts/shale-kottedzh/hr-65-iz-166.jpg'), active: false},
					{id: 26, src: require('../../src/assets/img/aparts/shale-kottedzh/hr-66-iz-166.jpg'), active: false},
					{id: 27, src: require('../../src/assets/img/aparts/shale-kottedzh/hr-67-iz-166.jpg'), active: false},
					{id: 28, src: require('../../src/assets/img/aparts/shale-kottedzh/hr-68-iz-166.jpg'), active: false},
					{id: 29, src: require('../../src/assets/img/aparts/shale-kottedzh/hr-69-iz-166.jpg'), active: false},
					{id: 30, src: require('../../src/assets/img/aparts/shale-kottedzh/hr-70-iz-166.jpg'), active: false},
					{id: 31, src: require('../../src/assets/img/aparts/shale-kottedzh/hr-71-iz-166.jpg'), active: false},
					{id: 32, src: require('../../src/assets/img/aparts/shale-kottedzh/hr-72-iz-166.jpg'), active: false},
					{id: 33, src: require('../../src/assets/img/aparts/shale-kottedzh/hr-73-iz-166.jpg'), active: false},
					{id: 37, src: require('../../src/assets/img/aparts/shale-kottedzh/hr-87-iz-166.jpg'), active: false},
				],
				area: 252,
				tags: ['Телевизор', 'Сплит-кондиционер', 'Wi-Fi', 'Room service', 'Мини-холодильник',
				'Мини бар', 'Микроволновая печь', 'Душ', 'Чайная станция', 'Халат, тапочки', 'Сейф'],
				description: `
					Шале — отдельностоящий дом в европейском стиле с панорамным видом на акваторию песчаного пляжа. 
					Комфортабельный дизайн с интерьером в спокойных оттенках — идеальный вариант для отдыха компаний 
					до 20 человек или семейных пар с детьми. 
					<br/>
					В шале есть все необходимое как для расслабленного, так и для активного отдыха — например, 
					собственная площадка с барбекю, на которой вы сможете приготовить любимые блюда. 
				`,
				text: '',
			},
			{
				id:  2,
				data_tl_room: '228051',
				type: {
					id: 3,
					name: 'capsule',
					img: require('../assets/img/aparts2/modulnye-domiki-cinema-capsule/cinema_capsule_outdor/hr-150-iz-166.jpg'),
					video: '',
				},
				active: false,
				title: 'КАПСУЛЬНЫЕ ДОМИКИ',
				subtitle: 'CINEMA CAPSULA',
				imgs: [
					{id: 1, src: require('../../src/assets/img/aparts/modulnye-domiki-cinema-capsule/hr-86-iz-166.jpg'), active: false},
					{id: 2, src: require('../../src/assets/img/aparts/modulnye-domiki-cinema-capsule/hr-88-iz-166.jpg'), active: false},
					{id: 3, src: require('../../src/assets/img/aparts/modulnye-domiki-cinema-capsule/hr-89-iz-166.jpg'), active: false},
					{id: 4, src: require('../../src/assets/img/aparts/modulnye-domiki-cinema-capsule/hr-90-iz-166.jpg'), active: false},
					{id: 5, src: require('../../src/assets/img/aparts/modulnye-domiki-cinema-capsule/hr-91-iz-166.jpg'), active: false},
					{id: 6, src: require('../../src/assets/img/aparts/modulnye-domiki-cinema-capsule/hr-92-iz-166.jpg'), active: false},
					{id: 7, src: require('../../src/assets/img/aparts/modulnye-domiki-cinema-capsule/hr-93-iz-166.jpg'), active: false},
					{id: 9, src: require('../../src/assets/img/aparts/modulnye-domiki-cinema-capsule/hr-95-iz-166.jpg'), active: false},
				],
				area: 13.5,
				tags: ['Телевизор', 'Сплит-кондиционер', 'Wi-Fi', 'Room service', 'Мини-холодильник',
				'Мини бар', 'Микроволновая печь', 'Душ', 'Чайная станция', 'Халат, тапочки', 'Мангал'],
				description: `
					15 круглогодичных модульных домов — полноценных номеров, оборудованных всем необходимым для комфортного 
					проживания в любое время года. 
					<br>
					Уютная cinema capsula — место где вы сможете расслабиться и получить новые впечатления и эмоции. 
					Главное преимущества  домика — собственный кинопроектор и панорамное большое окно со смарт-шторами, 
					управляемыми при помощи пульта. 
					<br>
					Общая площадь капсулы — 13,5 м², что идеально подходит как одноместного размещения, так и для пар. 
					Также в капсулу имеется возможность добавить третье спальное место. 
				`,
				text: `<p>Уютный, отдельно стоящий домик-капсула - место для паузы, где вы сможете восполнить
					энергию, зарядиться и получить новые яркие впечатления и эмоции.</p><p>Изюминка домика –
					собственный кинопроектор и панорамное большое окно со смарт-шторами (управление с помощью
					пульта).</p><br><p>Просторная капсула общей площадью 13,5 кв.м. отлично подойдет как для пар,
					так и для комфортного одноместного размещения.</p><p>Так же есть дополнительное место,
					что позволяет сделать размещение 3-х местным.</p>`,
			},
			{
				id:  3,
				data_tl_room: '46394',
				type: {
					id: 1,
					name: 'suite',
					img: '',
					video: '',
				},
				active: true, // todo: important
				title: 'ЛЮКС',
				subtitle: '',
				imgs: [
					{id: 1, src: require('../../src/assets/img/aparts/ljuks/hr-74-iz-166.jpg'), active: false},
					{id: 2, src: require('../../src/assets/img/aparts/ljuks/hr-75-iz-166.jpg'), active: false},
					{id: 3, src: require('../../src/assets/img/aparts/ljuks/hr-76-iz-166.jpg'), active: false},
					{id: 4, src: require('../../src/assets/img/aparts/ljuks/hr-77-iz-166.jpg'), active: false},
					{id: 5, src: require('../../src/assets/img/aparts/ljuks/hr-78-iz-166.jpg'), active: false},
					{id: 6, src: require('../../src/assets/img/aparts/ljuks/hr-79-iz-166.jpg'), active: false},
					{id: 7, src: require('../../src/assets/img/aparts/ljuks/hr-80-iz-166.jpg'), active: false},
				],
				area: 64,
				tags: ['Телевизор', 'Сплит-кондиционер', 'Wi-Fi', 'Room service', 'Мини-холодильник',
				'Мини бар', 'Микроволновая печь', 'Телефон', 'Душ', 'Чайная станция', 'Халат, тапочки', 'Сейф'],
				description: `
					Двухкомнатные номера в классическом или двухуровневом формате, расположенные на мансардном 
					этаже отеля. Идеальный вариант для тех, кто отдыхает с семьей или отдает предпочтение 
					просторным номерам с несколькими жилыми зонами. Помимо спальни, номер включает в себя гостиную 
					и две ванных комнаты со всем необходимым. Мансардные окна позволяют любоваться на ночное небо и 
					пропускают самые теплые солнечные лучи.
					<br>
					Большая двуспальная кровать и дополнительный диван позволяют с комфортом разместить трех 
					или четырех человек. 
				`,
				text: '',
			},
			{
				id:  4,
				data_tl_room: '46419',
				type: {
					id: 1,
					name: 'suite',
					img: '',
					video: '',
				},
				active: false,
				title: 'JUNIOR SUITE',
				subtitle: 'ПОЛУЛЮКС',
				imgs: [
					{id: 1, src: require('../../src/assets/img/aparts/dzhunior-sjuit/hr-25-iz-166.jpg'), active: false},
					{id: 2, src: require('../../src/assets/img/aparts/dzhunior-sjuit/hr-28-iz-166.jpg'), active: false},
					{id: 3, src: require('../../src/assets/img/aparts/dzhunior-sjuit/hr-29-iz-166.jpg'), active: false},
					{id: 4, src: require('../../src/assets/img/aparts/dzhunior-sjuit/hr-30-iz-166.jpg'), active: false},
					{id: 5, src: require('../../src/assets/img/aparts/dzhunior-sjuit/hr-31-iz-166.jpg'), active: false},
					{id: 6, src: require('../../src/assets/img/aparts/dzhunior-sjuit/hr-32-iz-166.jpg'), active: false},
					{id: 7, src: require('../../src/assets/img/aparts/dzhunior-sjuit/hr-33-iz-166.jpg'), active: false},
					{id: 8, src: require('../../src/assets/img/aparts/dzhunior-sjuit/hr-34-iz-166.jpg'), active: false},
					{id: 9, src: require('../../src/assets/img/aparts/dzhunior-sjuit/hr-35-iz-166.jpg'), active: false},
				],
				area: 61,
				tags: ['Телевизор', 'Сплит-кондиционер', 'Wi-Fi', 'Мини-холодильник',
				'Мини бар', 'Микроволновая печь', 'Телефон', 'Душ', 'Чайная станция', 'Халат, тапочки', 'Сейф'],
				description: `
					Двухкомнатные номера в классическом или двухуровневом формате, расположенные на третьем этаже отеля.
					 Уютный, просторный, но в то же время функциональный номер позволяет качественно отдохнуть 
					 всем гостям. Помимо спальни, номер включает в себя гостиную, рабочую зону и ванную комнату 
					 со всем необходимым. Окна позволяют любоваться на ночное небо и пропускают самые теплые 
					 солнечные лучи. 
					<br>
					Большая двуспальная кровать и дополнительный диван позволяют с комфортом разместить трех 
					или четырех человек.
				`,
				text: '',
			},
			{
				id:  5,
				data_tl_room: '223181',
				type: {
					id: 1,
					name: 'suite',
					img: '',
					video: '',
				},
				active: false,
				title: 'JUNIOR SUITE',
				subtitle: 'СТУДИЯ',
				imgs: [
					{id: 1, src: require('../../src/assets/img/aparts/dzhunior-sjuit/hr-25-iz-166.jpg'), active: false},
				],
				area: 35,
				tags: ['Телевизор', 'Сплит-кондиционер', 'Wi-Fi', 'Мини-холодильник',
				'Мини бар', 'Микроволновая печь', 'Телефон', 'Душ', 'Чайная станция', 'Халат, тапочки', 'Сейф'],
				description: `
					Уютный номер с собственной небольшой кухней и барной стойкой идеально подходит для тех, 
					кто не любит часто выходить на территорию комплекса. Пространство номера разделено на зону спальни, 
					кухни, а также отдельной ванной комнаты со всем необходимым. Панорамные окна позволяют любоваться 
					видом на территорию комплекса. 
					<br>
					Большая двуспальная кровать и дополнительный угловой диван позволяют с комфортом разместить 
					трех человек.
				`,
				text: '',
			},
			{
				id:  6,
				data_tl_room: '50934',
				type: {
					id: 1,
					name: 'suite',
					img: '',
					video: '',
				},
				active: false,
				title: 'СТАНДАРТ',
				subtitle: 'ДВУХМЕСТНЫЙ',
				imgs: [
					{id: 1, src: require('../../src/assets/img/aparts/standart-2-h-mestnyj/hr-16-iz-166.jpg'), active: false},
					{id: 2, src: require('../../src/assets/img/aparts/standart-2-h-mestnyj/hr-17-iz-166.jpg'), active: false},
					{id: 3, src: require('../../src/assets/img/aparts/standart-2-h-mestnyj/hr-18-iz-166.jpg'), active: false},
					{id: 4, src: require('../../src/assets/img/aparts/standart-2-h-mestnyj/hr-19-iz-166.jpg'), active: false},
					{id: 5, src: require('../../src/assets/img/aparts/standart-2-h-mestnyj/hr-20-iz-166.jpg'), active: false},
					{id: 6, src: require('../../src/assets/img/aparts/standart-2-h-mestnyj/hr-21-iz-166.jpg'), active: false},
					{id: 7, src: require('../../src/assets/img/aparts/standart-2-h-mestnyj/hr-22-iz-166.jpg'), active: false},
					{id: 8, src: require('../../src/assets/img/aparts/standart-2-h-mestnyj/hr-23-iz-166.jpg'), active: false},
					{id: 9, src: require('../../src/assets/img/aparts/standart-2-h-mestnyj/hr-24-iz-166.jpg'), active: false},
				],
				area: 65,
				tags: ['Телевизор', 'Сплит-кондиционер', 'Wi-Fi', 'Room service', 'Мини-холодильник',
				'Мини бар', 'Микроволновая печь', 'Телефон', 'Душ', 'Чайная станция', 'Халат, тапочки', ],
				description: `Сдержанная классика и исключительный комфорт для размещения
					пар и семей с детьми. Двуспальная кровать King Size, гостиная, функциональная
					ванная комната. Здесь есть необходимое для приятного отдыха. Номера данной
					категории разделены на прихожую, гостиную, спальню, ванную комнату.`,
				text: '',
			},
			{
				id:  7,
				data_tl_room: '141579',
				type: {
					id: 1,
					name: 'suite',
					img: '',
					video: '',
				},
				active: false,
				title: 'СТАНДАРТ',
				subtitle: 'DUPLEX',
				imgs: [
					{id: 1, src: require('../../src/assets/img/aparts/standart-duplex-exb/hr-81-iz-166.jpg'), active: false},
					{id: 2, src: require('../../src/assets/img/aparts/standart-duplex-exb/hr-82-iz-166.jpg'), active: false},
					{id: 3, src: require('../../src/assets/img/aparts/standart-duplex-exb/hr-83-iz-166.jpg'), active: false},
					{id: 4, src: require('../../src/assets/img/aparts/standart-duplex-exb/hr-84-iz-166.jpg'), active: false},
					{id: 5, src: require('../../src/assets/img/aparts/standart-duplex-exb/hr-85-iz-166.jpg'), active: false},
				],
				area: 23,
				tags: ['Телевизор', 'Сплит-кондиционер', 'Wi-Fi', 'Room service', 'Мини-холодильник',
				'Мини бар', 'Микроволновая печь', 'Душ', 'Чайная станция', 'Халат, тапочки', 'Сейф'],
				description: `
					Небольшой двухэтажный номер, расположенный на третьем этаже отеля. Уютное пространство прекрасно 
					подходит для двоих. В номере также есть рабочая зона, чайная станция и просторная ванная комната 
					со всем необходимым. 
					<br>
					Окна позволяют любоваться на ночное небо и пропускают самые теплые солнечные лучи. 
				`,
				text: '',
			},
			{
				id:  8,
				data_tl_room: '116078',
				type: {
					id: 1,
					name: 'suite',
					img: '',
					video: '',
				},
				active: false,
				title: 'СТАНДАРТ',
				subtitle: 'ДВУХМЕСТНЫЙ (МАНСАРДА)',
				imgs: [
					{id: 1, src: require('../../src/assets/img/aparts/standart-mansarda-2-h-mestnyj/hr-2-iz-166.jpg'), active: false},
					{id: 2, src: require('../../src/assets/img/aparts/standart-mansarda-2-h-mestnyj/hr-3-iz-166.jpg'), active: false},
					{id: 3, src: require('../../src/assets/img/aparts/standart-mansarda-2-h-mestnyj/hr-4-iz-166.jpg'), active: false},
					{id: 4, src: require('../../src/assets/img/aparts/standart-mansarda-2-h-mestnyj/hr-5-iz-166.jpg'), active: false},
					{id: 5, src: require('../../src/assets/img/aparts/standart-mansarda-2-h-mestnyj/hr-6-iz-166.jpg'), active: false},
					{id: 6, src: require('../../src/assets/img/aparts/standart-mansarda-2-h-mestnyj/standart-mansarda-2-h-mestnyj.jpg'), active: false},
				],
				area: 18,
				tags: ['Телевизор', 'Сплит-кондиционер', 'Wi-Fi', 'Room service', 'Мини-холодильник',
				'Мини бар', 'Микроволновая печь', 'Телефон', 'Душ', 'Чайная станция', 'Халат, тапочки', ],
				description: `
					Небольшой однокомнатный номер, расположенный на третьем этаже отеля. 
					Уютное пространство и двуспальная кровать прекрасно подходит для размещения пары. 
					В номере также есть рабочая зона, чайная станция и просторная ванная комната со всем необходимым. 
					<br>
					Мансардные окна позволяют любоваться на ночное небо и пропускают самые теплые солнечные лучи.
				`,
				text: '',
			},
			{
				id:  9,
				data_tl_room: '116079',
				type: {
					id: 1,
					name: 'suite',
					img: '',
					video: '',
				},
				active: false,
				title: 'СТАНДАРТ',
				subtitle: 'TWIN',
				imgs: [
					{id: 1, src: require('../../src/assets/img/aparts/standart-twin/hr-8-iz-166.jpg'), active: false},
					{id: 2, src: require('../../src/assets/img/aparts/standart-twin/hr-9-iz-166.jpg'), active: false},
					{id: 3, src: require('../../src/assets/img/aparts/standart-twin/hr-10-iz-166.jpg'), active: false},
					{id: 4, src: require('../../src/assets/img/aparts/standart-twin/hr-11-iz-166.jpg'), active: false},
					{id: 5, src: require('../../src/assets/img/aparts/standart-twin/hr-12-iz-166.jpg'), active: false},
					{id: 6, src: require('../../src/assets/img/aparts/standart-twin/hr-13-iz-166.jpg'), active: false},
					{id: 7, src: require('../../src/assets/img/aparts/standart-twin/hr-14-iz-166.jpg'), active: false},
					{id: 8, src: require('../../src/assets/img/aparts/standart-twin/hr-37-iz-166.jpg'), active: false},
					{id: 9, src: require('../../src/assets/img/aparts/standart-twin/hr-38-iz-166.jpg'), active: false},
					{id: 10, src: require('../../src/assets/img/aparts/standart-twin/hr-39-iz-166.jpg'), active: false},
					{id: 11, src: require('../../src/assets/img/aparts/standart-twin/hr-40-iz-166.jpg'), active: false},
				],
				area: 18,
				tags: ['Телевизор', 'Сплит-кондиционер', 'Wi-Fi', 'Room service', 'Мини-холодильник',
				'Мини бар', 'Микроволновая печь', 'Телефон', 'Душ', 'Чайная станция', 'Халат, тапочки', ],
				description: `
					Небольшой однокомнатный номер, расположенный на третьем этаже отеля. Односпальные кровати 
					идеально подходят для комфортного размещения двух человек.  В номере также есть рабочая зона, 
					чайная станция и ванная комната со всем необходимым. 
				`,
				text: '',
			},
		],
	},
	getters: {
		screenScrolled: state => {
			return state.screenScrolled
		},
		screenWidth: state => {
			return state.screenWidth
		},
		screenHeight: state => {
			return state.screenHeight
		},
		isModalShow: state =>  {
			return state.isModalShow
		},
		housingItems: state =>  {
			return state.housing_items
		}

	},
	actions: {
		screenScrolledAction(context, payload) {
			context.commit('screenScrolledMut', payload)
		},
		screenWidthAction(context, payload) {
			context.commit('screenWidthMut', payload)
		},
		screenHeightAction(context, payload) {
			context.commit('screenHeightMut', payload)
		},
		isModalShowAction(context, payload)  {
			context.commit('isModalShowMut', payload)
		},
		GetHousingItemsAction(context, payload)  {
			context.commit('housingItemsMut', payload)
		},
	},
	mutations: {
		screenScrolledMut(state, payload)  {
			state.screenScrolled = payload
		},
		screenWidthMut(state, payload)  {
			state.screenWidth = payload
		},
		screenHeightMut(state, payload)  {
			state.screenHeight = payload
		},
		isModalShowMut(state, payload)   {
			state.isModalShow = payload
		},
		housingItemsMut(state, payload)   {
			state.isModalShow = payload
		},
	},
})
